// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:09:36

export default {
  "id": "merge-racer-stunts-car",
  "slug": "merge-racer-stunts-car",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c51d49fbd27040a99af520d9319ff911-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c51d49fbd27040a99af520d9319ff911/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Racer Stunts Car",
      "description": "Welcome to Merge Racer - Stunts Car! This is an exciting and creative racing game. You show your driving skills and use the power of merge to build supercars! Merge the same types of cars to create stronger racing machines. Each merge improves your car’s performance, helping\nyou speed ahead of your rivals.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "car",
        "flip",
        "jumping"
      ]
    },
    "zh-CN": {
      "title": "融合竞速特技赛车",
      "description": "欢迎来到《合并赛车 - 魔术赛车》！这是一款激动人心且富有创意的赛车游戏。展示你的驾驶技巧，利用合并的力量打造超级赛车！合并相同类型的赛车，创造更强大的赛车机械。每一次合并都会提升你的赛车性能，助你领先竞争对手。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "汽车",
        "翻转",
        "跳跃"
      ]
    },
    "zh-TW": {
      "title": "合併賽車特技車",
      "description": "歡迎來到合體競速－特技車！這是一款刺激創意的賽車遊戲。您將展示您的駕駛技巧，並利用合體的力量打造超級賽車！合體同型車輛以創造更強大的賽車機器。每次合體都會提升您車輛的性能，幫助您超越對手。",
      "instructions": "用滑鼠點擊或觸控以開始遊戲",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "車",
        "翻轉",
        "跳躍"
      ]
    },
    "zh-HK": {
      "title": "合體賽車特技",
      "description": "歡迎來到合併賽車 - 縱橫翻騰！這是一款刺激創意的賽車遊戲。你將展現你的駕駛技巧，並利用合併的力量打造超級賽車！合併同類型的車輛，創造更強大的賽車機器。每次合併都會提升你的車輛性能，幫助你超越對手。",
      "instructions": "用滑鼠點擊或輕觸遊玩",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "車",
        "翻轉",
        "跳躍"
      ]
    },
    "ja": {
      "title": "マージレーサー スタントカー",
      "description": "マージレーサー - スタントカーへようこそ！これは刺激的で創造的なレースゲームです。あなたの運転スキルを披露し、マージの力を使ってスーパーカーを築きましょう！同じタイプの車をマージして、より強力なレーシングマシンを作り出します。それぞれのマージであなたの車のパフォーマンスが向上し、ライバルを寄せ付けずにスピーディーに進むことができます。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "レーシング＆ドライビング"
      ],
      "tags": [
        "車",
        "転がり",
        "ジャンプ"
      ]
    },
    "ko": {
      "title": "혼합 레이서 스타운츠 카ー",
      "description": "MERGE RACER - 스탠트스 카!에 오신 것을 환영합니다! 이는 흥미롭고 창의적인 레이싱 게임입니다. 드라이빙 기술을 보여주고 합병의 힘을 사용하여 슈퍼카를 만들어보세요! 같은 유형의 차를 합병하여 강력한 레이싱 기계를 만들어보세요. 각 합병은 차의 성능을 향상시켜, 상대를 앞서가는 데 도움이 됩니다.",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "カー",
        "フリップ",
        "ジャンプ"
      ]
    },
    "fr": {
      "title": "Course de fusion Stunts Car",
      "description": "Bienvenue dans Merge Racer - Stunts Car ! C'est un jeu de course passionnant et créatif. Montrez vos compétences en conduite et utilisez la puissance de la fusion pour construire des supercars ! Fusionnez les mêmes types de voitures pour créer des machines de course plus puissantes. Chaque fusion améliore les performances de votre voiture, vous aidant à vous démarquer de vos rivaux.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Course et conduite"
      ],
      "tags": [
        "car",
        "renverser",
        "sauter"
      ]
    }
  }
};
